module.exports = __webpack_public_path__ + "bg-photo-tablet-portrait.webp?cce4ce925b86607c51bd2f672aeb7c04";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-photo-tablet-portrait.webp
// module id = 202
// module chunks = 0